function doHandleFreeGifts(cart) {
  try {
    if (cart.item_count > 0) {
      let data = { updates: {} };
      for (let i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_description.indexOf("#freegift#") > 0) {
          let freegiftvalue = Number(
            cart.items[i].product_description.split("#freegift#")[1]
          );
          if ((cart.total_price/Shopify.currency.rate) < freegiftvalue) {
            data.updates[cart.items[i].id] = 0;
          } else if (cart.items[i].quantity > 1) {
            data.updates[cart.items[i].id] = 1;
          }
        }
      }
      if (Object.keys(data.updates).length > 0) {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: data,
          dataType: "json",

          complete: function (data) {
            location.reload();
          },
        });
      }
    }
  } catch (err) {
    console.log(err);
  }
}

function checkIfNoItemsDropdownCart() {
  var sidebarCart = $("#sidebar-cart"),
    btnRemove = sidebarCart.find(".btn-remove"),
    sidebarCartNoItems = sidebarCart.find(".cart-empty"),
    sidebarCartHasItems = sidebarCart.find(".mini-products-list"),
    sidebarCartFooter = sidebarCart.find(".cart-footer");

  var cartNoItems = $("#dropdown-cart .no-items"),
    cartHasItems = $("#dropdown-cart .has-items");

  if ($("#dropdown-cart .mini-products-list").children().length) {
    cartHasItems.show();
    cartNoItems.hide();


    let sliderforswiper = new Swiper(".side-cart-upsell-list", {
      speed: 400,
      spaceBetween: 5,
      slidesPerView: 2,
      slidesPerGroupSkip: 2,
      grabCursor: true,
      parallax: true,
      
      
      navigation: {
        nextEl: '.side-cart-upsell-list .swiper-button-next',
        prevEl: '.side-cart-upsell-list .swiper-button-prev',
      },
    });
    
    sidebarCartNoItems.hide();
    sidebarCartHasItems.show();
    sidebarCartFooter.show();
  } else {
    cartHasItems.hide();
    cartNoItems.show();

    sidebarCartNoItems.show();
    sidebarCartHasItems.hide();
    sidebarCartFooter.hide();
  }
}

function getPopupShoppingCart(shouldShowModel, handle) {
  var ajaxCartModal = $("[data-ajax-cart-success]"),
    modalContent = ajaxCartModal.find(".cart-popup-content"),
    collUpsell = ajaxCartModal.find(".cart-popup-coll-related");

    updateDropdownCart();

    if (!$("html").is(".cart-show"))
    {  
      $("[data-cart-toggle]").click();
    }
}

function closeSuccessModal() {
  var ajaxCartModal = $(
      "[data-ajax-cart-success], [data-quickview-modal], [data-compare-modal], [data-compare-message-modal]"
    ),
    editCart = $("[data-cart-edit-modal]"),
    closeWindow = ajaxCartModal.find(".close-modal, .continue-shopping"),
    modalContent = ajaxCartModal.find(".halo-modal-content"),
    closeEdit = editCart.find(".close-modal"),
    modalContentEdit = editCart.find(".halo-modal-content");

  closeWindow.click(function (e) {
    e.preventDefault();
    ajaxCartModal.fadeOut(500, function () {
      $("html").removeClass("halo-modal-open");
      $("html").css({
        overflow: "",
      });

    });

    function postMessageToPlayer(player, command) {
      if (player == null || command == null) return;
      player.contentWindow.postMessage(JSON.stringify(command), "*");
    }

    if (
      $("[data-more-view-product-qv] .product-img-box .slider-for")
        .find(".slick-current")
        .find("iframe").length
    ) {
      var player = $(".slider-for")
        .find(".slick-current")
        .find("iframe")
        .get(0);
      postMessageToPlayer(player, {
        event: "command",
        func: "pauseVideo",
      });

      // player.pause();
    }
    if (
      $("[data-more-view-product-qv] .product-img-box .slider-for")
        .find(".slick-current")
        .find("video").length
    ) {
      var video = $(".slider-for")
        .find(".slick-current")
        .find("video")
        .get(0);
      video.pause();
    }
  });

  ajaxCartModal.on("click", function (e) {
    if (!modalContent.is(e.target) && !modalContent.has(e.target).length) {
      ajaxCartModal.fadeOut(500, function () {
        $("html").removeClass("halo-modal-open");
        $("html").css({
          overflow: "",
        });
      });

      function postMessageToPlayer(player, command) {
        if (player == null || command == null) return;
        player.contentWindow.postMessage(JSON.stringify(command), "*");
      }

      if (
        $("[data-more-view-product-qv] .product-img-box .slider-for")
          .find(".slick-current")
          .find("iframe").length
      ) {
        var player = $(".slider-for")
          .find(".slick-current")
          .find("iframe")
          .get(0);
        postMessageToPlayer(player, {
          event: "command",
          func: "pauseVideo",
        });

        // player.pause();
      }
      if (
        $("[data-more-view-product-qv] .product-img-box .slider-for")
          .find(".slick-current")
          .find("video").length
      ) {
        var video = $(".slider-for")
          .find(".slick-current")
          .find("video")
          .get(0);
        video.pause();
      }
    }
  });
  closeEdit.on("click", function (e) {
    e.preventDefault();
    $("[data-cart-edit-modal]").fadeOut(500, function () {
      html.removeClass("halo-modal-open");
      html.css({
        overflow: "",
      });
    });
  });

  $("[data-cart-edit-modal]").on("click", function (e) {
    if (
      !modalContentEdit.is(e.target) &&
      !modalContentEdit.has(e.target).length
    ) {
      $("[data-cart-edit-modal]").fadeOut(500, function () {
        html.removeClass("halo-modal-open");
        html.css({
          overflow: "",
        });
      });
    }
  });
}

function showLoading() {
  $(".loading-modal").show();
}

function hideLoading() {
  $(".loading-modal").hide();
}

function showModal(selector) {
  $(selector).fadeIn(500);

  setTimeout(function () {
    $(selector).fadeOut(500);
  }, 5000);
}

function doAjaxUpdatePopupCart(quantity, id, productItem) {
  let isCompoundItem = $(productItem).is("[data-product-ids]");
  let ajaxurl = "/cart/update.js";

  data = { updates: {} };
  data.updates[id] = quantity;
  if (isCompoundItem) {
    var itemsProcessed = $(productItem).attr("data-product-ids");
    var itemsArray = itemsProcessed.split(",").filter((item) => item);
    var qty = 0;
    data = { updates: {} };

    for (i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = quantity;
    }
  }
  $.ajax({
    type: "POST",
    url: ajaxurl,
    data: data,
    dataType: "json",

    beforeSend: function () {
      showLoading();
    },

    success: function (result) {
      getPopupShoppingCart(false);
      if (
        result.cart_level_discount_applications.length > 0 &&
        $("[data-cart-discount-wrapper]").length
      ) {
        var cartDiscounts = result.cart_level_discount_applications;
        var title = cartDiscounts[0].title;
        var total_discount = cartDiscounts[0].total_allocated_amount;
        $("[data-cart-discount-wrapper]").show();
        $("[data-cart-discount-title]").text(title);
        $("[data-cart-discount-amount]").html(
          Shopify.formatMoney(total_discount, window.money_format)
        );
      } else {
        $("[data-cart-discount-wrapper]").hide();
      }
    },

    error: function (xhr) {
      $(".ajax-error-message").text(
        $.parseJSON(xhr.responseText).description
      );
      showModal(".ajax-error-modal");
    },

    complete: function () {
      hideLoading();
    },
  });
}

function initChangeQuantityButtonEvent() {
  // just a trigger proxy for the input
  var buttonSlt = "[data-minus-quantity-cart], [data-plus-quantity-cart]",
    buttonElm = $(buttonSlt);
  
  $("body")
    .off("click.updateCart")
    .on("click.updateCart", buttonSlt, function (e) {
      e.preventDefault();
      e.stopPropagation();
      var qty = $(this).siblings("input[type=number]");
      var val = parseInt(qty.val());
      if ($(this).hasClass("plus")){
          val++;
      } 
      else if ($(this).hasClass("minus"))
      {
         val--;
      }
      qty.val(val);
      qty.trigger("change");
    });
}

function initQuantityInputChangeEvent() {
  var quantityIptSlt = "[data-quantity-input]";
  $("body").on("change", quantityIptSlt, function () {
    var id = $(this).closest("[data-product-id]").data("product-id"),
      quantity = parseInt($(this).val());
    var productItem = $(this).closest("[data-product-id]");
    doAjaxUpdatePopupCart(quantity, id, productItem);
  });
}

function removeCartItem() {
  var removeSlt = ".cart-remove";

  $("body").on("click", removeSlt, function (e) {
    e.preventDefault();
    e.stopPropagation();

    var productItem = $(this).closest("[data-product-id]");
    var id = $(this).closest("[data-product-id]").data("product-id");

    doAjaxUpdatePopupCart(0, id, productItem);
  });
}

function removeItemDropdownCart(cart) {
  var btnRemove = $("#dropdown-cart").find(".btn-remove");
  var btnUpdate = $("#dropdown-cart").find(".item-quantity");

btnRemove
  .off("click.removeCartItem")
  .on("click.removeCartItem", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var productId = $(this).parents(".item").attr("id");
    productId = productId.match(/\d+/g);

    var btn = $(this);
    var id = btn.closest("[data-product-id]").data("product-id");
    var productItem = btn.closest("[data-product-id]");
    doAjaxUpdatePopupCart(0, id, productItem);
  });
btnUpdate
  .off("change.addCartItem")
  .on("change.addCartItem", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var btn = $(this);
    var id = btn.closest("[data-product-id]").data("product-id");
    var productItem = btn.closest("[data-product-id]");
    var quantity = parseInt(btn.val());
    $(this).parents(".item").addClass("cur--change");
    doAjaxUpdatePopupCart(quantity, id, productItem);
  });
}

function updateDropdownCart() {
  Shopify.getCart(function (cart) {
      var template =
        '<li class="item" id="cart-item-{ID}" data-product-id="{ID}"><a href="{URL}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a class="product-name" href="{URL}">{TITLE}</a><div class="option"><small>{VARIANT}</small></div><div class="cart-collateral">{PRICE}{DISCOUNT}</div><div class="quantity qty-group"><a href="#" data-minus-quantity-cart="" class="minus button"></a><input class="item-quantity" name="quantity" id="updates_{ID}" data-qtt-id1="quantity_{ID}" value="{QUANTITY}" type="number" /><a href="#" data-plus-quantity-cart="" class="plus button"></a><span class="error-message-input"></span></div></div><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><svg aria-hidden="true" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg></a></li>';
      var compoundtemplate =
        '<li class="item" id="cart-item-{ID}" data-product-id="{ID}" data-product-ids="{IDS}"><a href="{URL}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a class="product-name" href="{URL}">{TITLE}</a><div class="option"><small>{VARIANT}</small></div><div class="cart-collateral">{PRICE}{DISCOUNT}</div><div class="quantity qty-group"><a href="#" data-minus-quantity-cart="" class="minus button"></a><input class="item-quantity" name="quantity" id="updates_{ID}" data-qtt-id1="quantity_{ID}" value="{QUANTITY}" type="number" /><a href="#" data-plus-quantity-cart="" class="plus button"></a><span class="error-message-input"></span></div></div><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><svg aria-hidden="true" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg></a></li>';

      $(".wrapper-cartCount").show();
      $("#dropdown-cart")
        .find(".summary .price")
        .html(Shopify.formatMoney(cart.total_price, window.money_format));
      $("#sidebar-cart")
        .find(".cart-footer .notranslate")
        .html(Shopify.formatMoney(cart.total_price, window.money_format));
      $("#dropdown-cart .mini-products-list").hide();
      $("#dropdown-cart .mini-products-list").html("");
      let countVisibleItems = 0;
      if (cart.item_count > 0) {
        var item_id = $(".item.cur--change").data("product-id");
        var line_item = parseInt(
          $(".item.cur--change").find('input[name="quantity"]').data("line")
        );
        var quantity = parseInt(
          $(".item.cur--change").find('input[name="quantity"]').val()
        );
        var productids = [];
        for (var i = 0; i < cart.items.length; i++) {
          var item = template;
          if (cart.items[i].hasOwnProperty("product_type") &&
              cart.items[i].product_type == "OPTIONS_HIDDEN_PRODUCT")
          {
            continue;
          }
          if (i == 0) {
            $("#dropdown-cart .mini-products-list").html("");
          }

          if (
            cart.items[i].hasOwnProperty("properties") &&
            cart.items[i].properties != null &&
            cart.items[i].properties.hasOwnProperty("_unicubeitem")
          ) {
            continue;
          }

          countVisibleItems += cart.items[i].quantity;
          let totalprice = 0;
          let totalpricefinal = 0;
          if (
            cart.items[i].properties != null &&
            cart.items[i].properties.hasOwnProperty("_itemhash")
          ) {
            productids = [];
            for (var j = 0; j < cart.items.length; j++) {
              if (
                cart.items[j].properties != null &&
                cart.items[j].properties.hasOwnProperty("_itemhash") &&
                cart.items[i].properties._itemhash ==
                  cart.items[j].properties._itemhash
              ) {
                productids.push(cart.items[j].key);
                totalprice += cart.items[j].price * cart.items[j].quantity;
                totalpricefinal += cart.items[j].final_price * cart.items[j].quantity;
              }
            }
            item = compoundtemplate.replace(/\{IDS\}/g, productids.join(","));
          }

          var cur_id = cart.items[i].id;
          var arr = [];

          if (
            cart.items[i].product_description &&
            (cart.items[i].product_description.indexOf("#stickers#") > 0 ||
              cart.items[i].product_description.indexOf("#freegift#") > 0)
          ) {
            item = item.replace(
              '<input class="item-quantity" name="quantity" id="updates_{ID}" data-qtt-id1="quantity_{ID}" value="{QUANTITY}" type="number" />',
              ""
            );
          }

          item = item.replace(/\{ID\}/g, cart.items[i].id);
          item = item.replace(/\{URL\}/g, cart.items[i].url);
          item = item.replace(
            /\{TITLE\}/g,
            cart.items[i].product_title
          );
          item = item.replace(
            /\{VARIANT\}/g,
            cart.items[i].variant_title || ""
          );
          item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
          item = item.replace(
            /\{IMAGE\}/g,
            Shopify.resizeImage(cart.items[i].image, "160x")
          );

          let discount_text = "";
          if (cart.items[i].discounts.length > 0)
          {
              for (let discountName of cart.items[i].discounts) {
                discount_text += "<div class='price-discount-code'>"+discountName.title+'</div>';
              }
          }
          item = item.replace(/\{DISCOUNT\}/g, discount_text);
          
          let pricestr = "";
         
          
          if (
            cart.items[i].properties != null &&
            cart.items[i].properties.hasOwnProperty("_itemhash")
          ) {
             if (totalprice != totalpricefinal)
              {
                pricestr+= "<span class='price-before me-2'>" + Shopify.formatMoney(totalprice, window.money_format) + "</span>";
              }
              pricestr+= '<span class="price">'+Shopify.formatMoney(totalpricefinal, window.money_format)+'</span>';
          } else {
               if (cart.items[i].price != cart.items[i].final_price)
              {
                pricestr+= "<span class='price-before me-2'>" + Shopify.formatMoney(cart.items[i].final_price, window.money_format) + "</span>";
              }
              pricestr+= '<span class="price">'+Shopify.formatMoney(cart.items[i].final_price, window.money_format)+'</span>';
          }

          item = item.replace(
              /\{PRICE\}/g,
              pricestr
            );
          
          $("#dropdown-cart .mini-products-list").append(item);
          
          if (quantity > line_item && line_item > 0) {
            $('#dropdown-cart [data-product-id="' + item_id + '"]')
              .find(".error-message-input")
              .html(
                '<i class="fa fa-exclamation-circle"></i>' +
                  window.inventory_text.warning_quantity +
                  ": " +
                  line_item
              );
          } else {
            $('#dropdown-cart [data-product-id="' + item_id + '"]')
              .find(".error-message-input")
              .text("");
          }

          $.ajax({
            url: "/products/" + cart.items[i].handle + "?view=cart_edit",
            success: function (data) {
              var json = $(data).find(".get_script_content").data("array_json");
              arr = json.filter(function (cur) {
                return parseInt(cur.id) === cur_id;
              });
              if (arr.length) {
                $('#dropdown-cart [data-product-id="' + cur_id + '"]')
                  .find('[name="quantity"]')
                  .attr("data-line", arr[0].value);
              }
            },
          });

          if (
            cart.cart_level_discount_applications.length > 0 &&
            $("[data-cart-discount-wrapper]").length
          ) {
            var cartDiscounts = cart.cart_level_discount_applications;
            var title = cartDiscounts[0].title;
            var total_discount = cartDiscounts[0].total_allocated_amount;
            $("[data-cart-discount-wrapper]").show();
            $("[data-cart-discount-title]").text(title);
            $("[data-cart-discount-amount]").html(
              Shopify.formatMoney(total_discount, window.money_format)
            );
          } else {
            $("[data-cart-discount-wrapper]").hide();
          }
        }
        $(".cart-sidebar-products").show();
        
        // remove events
        removeItemDropdownCart();
        
      } else {
        $("#dropdown-cart .mini-products-list").html("");
        $(".cart-sidebar-products").hide();
        $(".wrapper-cartCount").hide();
      }
      $("[data-cart-count]").text(countVisibleItems);
      $("#dropdown-cart .mini-products-list").show();
      hideLoading();
      //editCart();
      checkIfNoItemsDropdownCart();
      doHandleFreeGifts(cart);
  });
}

function doAjaxAddToCart(data, title, image) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
  
    beforeSend: function () {
      showLoading();
    },
  
    success: function () {
      var ajaxCartModal = $("[data-ajax-cart-success]"),
        modalContent = ajaxCartModal.find(".cart-modal-content");
  
      modalContent
        .find(".ajax-product-title")
        .html(title);
      modalContent.find(".ajax-product-image").attr("src", image);
      modalContent.find(".message-added-cart").show();
      closeAllMenusAndModals();
      ajaxCartModal.fadeIn(600, function () {
        $("html").addClass('halo-modal-open');
  
        if ($("[data-quickview-modal]").is(":visible")) {
          $("[data-quickview-modal]").hide();
        }
  
        $(".ajax-lookbook-modal").fadeOut(500);
      });
      
      updateDropdownCart();
      
    },
  
    error: function (xhr) {
      hideLoading();
      $(".ajax-error-message").text(
        $.parseJSON(xhr.responseText).description
      );
      showModal(".ajax-error-modal");
    },
  
    complete: function () {
      hideLoading();
    },
  });
};

function doAjaxAddToCartWithFiles(item, handle) {
  const formData = new FormData();

  formData.append('id', item.id);
  formData.append('quantity', item.quantity || 1);

  // Append other properties (non-file)
  if (item.properties) {
    Object.keys(item.properties).forEach(key => {
      const value = item.properties[key];
      if (value instanceof File) return; // skip files
      formData.append(`properties[${key}]`, value);
    });
  }

  // Append cube face files (inputs named images[FaceName])
  $('input[type="file"][name^="images["]').each(function() {
    const input = this;
    if (input.files.length > 0) {
      const match = input.name.match(/^images\[(.+)\]$/);
      if (match) {
        const key = match[1];
        formData.append(`properties[${key}]`, input.files[0]);
      }
    }
  });

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    beforeSend: function() {
      closeAllMenusAndModals();
      showLoading();
    },
    success: function(data) {
      getPopupShoppingCart(true, handle);
    },
    error: function(xhr) {
      $(".ajax-error-message").text(
        $.parseJSON(xhr.responseText).description
      );
      showModal(".ajax-error-modal");
      hideLoading();
    },
    complete: function() {
      // optional cleanup
    }
  });
}

function doAjaxAddToCartWUpsell(data, handle, nojax) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    async: false,
    beforeSend: function () {
      closeAllMenusAndModals();
      showLoading();
    },
  
    success: function (data) {
      if (!nojax) {
        getPopupShoppingCart(true, handle);
        
      }
    },
  
    error: function (xhr) {
      $(".ajax-error-message").text(
        $.parseJSON(xhr.responseText).description
      );
      showModal(".ajax-error-modal");
      hideLoading();
    },
  
    complete: function () {
      //hideLoading();
    },
  });
};

function initAddToBundle() {
let btnAddToCartSlt = "[data-btn-addBundleToCart]";
$(document)
  .off("click.addToCart", btnAddToCartSlt)
  .on("click.addToCart", btnAddToCartSlt, function (e) {
    e.preventDefault();
    e.stopPropagation();
    let itemhash = new Date().getTime();
    let self = $(this);
    let formdata = new FormData();
    let returnArray = {};
    

    var scsformdata = {
      items: [returnArray],
    };

    // bundle products
    let bundleitems = {};
    $(".bundle-cart-item.active").each(function (index) {
      var variantid = $(this).attr("data-item-id");
      var variantquantity = 1;
      var props = {};
      props["_bundle"] = $("#collection_title").text();
      //props["_itemhash"] = itemhash+"_"+index;
      if ($(this).is("[data-item-backorder]"))
          props["_backorder"] = $(this).attr("data-item-backorder");
      if ($(this).is("[data-item-shipdays]"))
          props["_shipdays"] = $(this).attr("data-item-shipdays");
      
      if (variantid != "-1") {
        if (bundleitems.hasOwnProperty(variantid))
        {
          bundleitems[variantid].quantity++;
        }
        else
        {
          bundleitems[variantid] = {
            quantity: variantquantity,
            id: variantid,
            properties: props,
          }
        }
      }            
    });
    for (var bundleitemid in bundleitems) {
        if (bundleitems.hasOwnProperty(bundleitemid)) {
          scsformdata.items.push(bundleitems[bundleitemid]);
        }
    }

    
    if (self.attr("disabled") !== "disabled") {
      let title=$("#collection_title").text();
      let image = $("#collection_image").attr("src");
      doAjaxAddToCartWUpsell(scsformdata, "'/collections/?view=related'");

    }
    if ($(".cart-template").length != 0) {
      let dss = $(this).attr("data-threshold");
      $("[data-threshold='" + dss + "']").attr("disabled", true);
      $("[data-threshold='" + dss + "']").text("Locked");
      try {
        Shopify.getCart(function (cart) {
          doHandleFreeGifts(cart);
        });
      } catch (err) {
        console.log(err);
      }
    }
    return false;
  });

closeSuccessModal();
}

function initAddToCart() {
  
  $("body").on("click","[data-btn-addtocart]",function (e) {
      e.preventDefault();
      e.stopPropagation();
      let itemhash = new Date().getTime();
      let self = $(this);
      let thisForm = $(self.data("form-id"));
      let data = thisForm.serialize();
      let formdata = new FormData();
      let formArray = $(thisForm).serializeArray();

      var applytovalue = "NA";
      try {
        if ($("#product-selectors option:selected").attr("data-sku") != undefined)
        {
          applytovalue = $("#product-selectors option:selected").attr("data-sku");
        }
      } catch (error) {
        
      }
    
      if ($("body").hasClass("template-product") && 
          (thisForm.attr("id") == "form-sticky" ||
           thisForm.attr("id") == "add-to-cart-form"))
      {
        formArray = $("#form-sticky,#add-to-cart-form").serializeArray();
      }
      
      let returnArray = {};
      let quantity = $("#add-to-cart-form input[name=quantity]").val();
      if (!quantity) {
        quantity = 1;
      }

      for (let i = 0; i < formArray.length; i++) {
        if (formArray[i]["name"] == "properties[_shipdays]" && 
            (
                formArray[i]["value"].length == 0 ||
                formArray[i]["value"] == "0"
            ))
        {
          continue;
        }

        
        try {
          if (formArray[i]["name"] == "added-line-items" && formArray[i]["value"].length != 0)
          {
            
            returnArray["properties[_itemhash]"] = itemhash;
            let prods = formArray[i]["value"].split("\n");
            for (let jx=0; jx<prods.length; jx++)
            {
              returnArray["properties[Bundle Product #" + (jx+1) + "]"] = prods[jx];
            }
           }
        }
        catch(err)
        {
          console.log(err);
        }
        
        if (formArray[i]["name"] == "properties[_backorder]" && 
            (
                formArray[i]["value"].length == 0 ||
                formArray[i]["value"] == "0"
            ))
        {
          continue;
        }
        
        if (formArray[i]["value"] != "No"
           &&
            formArray[i]["name"] != "properties[Stickers]")
           {
             
            returnArray[formArray[i]["name"]] = formArray[i]["value"];
          }
      }

      // custom stickers
      if (
        $(".blackonly").is(":visible") &&
        $("#stickerCustom").is(":checked")
      ) {
        returnArray["properties[Custom Stickers]"] = "Y |";
        
        returnArray["properties[_itemhash]"] = itemhash;
        thisForm.find(".colorSelect_selectedvalue").each(function () {
          returnArray["properties[" + $(this).attr("data-face") + "]"] =
            $(this).attr("data-title") + "        |";
        });
      }

      var scsformdata = {
        items: [returnArray],
      };

      // sticker products
      thisForm.find(".sticker-prod:checked").each(function () {
        
        returnArray["properties[_itemhash]"] = itemhash;
        var variantid = $(this).attr("data-pid");
        //var parentvariantid = $("select#product-selectors").val();
        var variantquantity = $(this).is("[data-quantity]")
          ? $(this).attr("data-quantity")
          : 1;
       
        
        if (variantid != "-1") {
          scsformdata.items.push({
            quantity: variantquantity,
            id: variantid,
            properties: { _itemhash: itemhash, _unicubeitem: "true" },
          });
        }
        try {
          scsformdata.items[0][$(this).attr("name")] = variantquantity;
        } catch (error) {
          console.error(error);
          // expected output: ReferenceError: nonExistentFunction is not defined
          // Note - error messages will vary depending on browser
        }
      });

      if ($(thisForm).find("#product-add-to-cart-pro-setup:checked").length > 0) {
        
        returnArray["properties[_itemhash]"] = itemhash;
        returnArray["properties[Logo Sticker]"] = $(
          "#product-add-to-cart-pro-setup:checked"
        ).attr("data-variant-name");
        returnArray["properties[.Apply Pro Setup]"] = "Yes";
        let vid = $("#product-add-to-cart-pro-setup:checked").attr(
          "data-variant-id"
        );
        scsformdata.items.push({
          quantity: quantity,
          id: vid,
          properties: {
            _itemhash: itemhash,
            _unicubeitem: "true",
            _shipdays: 3,
            _applyto: applytovalue
          },
        });
      }

      // added products
      $(thisForm).find(".unicube-prod:checked").each(function () {
        if (
          $(this).is("[data-empty]") &&
          $(this).attr("data-empty") == "true"
        ) {
          return;
        }
        
        returnArray["properties[_itemhash]"] = itemhash;
        var variantid = $(this).attr("data-pid");

        // dont add special removal for cosmic cubes if there are not stickers there
        if (
          variantid == "32265574154353" &&
          $("#unicube-stickers-tap-open").is(":visible") == false
        ) {
          return;
        }
        if (variantid != "-1") {
          scsformdata.items.push({
            quantity: quantity,
            id: variantid,
            properties: { _itemhash: itemhash, _unicubeitem: "true",
            _applyto: applytovalue },
          });
        }
      });
      // Add on Products
      $(".unicube-accessory:checked").each(function () {
        var variantid = $(this).attr("data-variant-id");
        
        scsformdata.items.push({ quantity: quantity, id: variantid,
            _applyto: applytovalue });
      });

      // added products
      $(".unicube-added-prod:checked").each(function () {
        var variantid = $(this).attr("data-pid");
        if (variantid != "-1") {
          scsformdata.items.push({ quantity: 1, id: variantid,
            _applyto: applytovalue });
        }
        
        returnArray["properties[_itemhash]"] = itemhash;
      });

      if (self.attr("disabled") !== "disabled") {
        var productItem = self.closest(".product-item");

        if (productItem.length < 1) {
          var sectionsProduct = self.closest(
            '[data-section-type="product"]'
          );

          if (!sectionsProduct.length) {
            sectionsProduct = self.closest(".quickview-tpl");
          }

          productItem = sectionsProduct.find(".product-shop");
        }

        var form = self.closest("form"),
          handle =
            productItem
              .find(".product-grid-image")
              .data("collections-related") ||
            sectionsProduct.data("collections-related");

          var title = productItem.find(".product-title").html();
          var image = productItem
            .find(".product-grid-image img")
            .attr("data-srcset");

          if (!image) {
            image =
              productItem
                .siblings(".product-photos")
                .find('.slick-current img[id|="product-featured-image"]')
                .attr("src") ||
              productItem
                .siblings(".product-photos")
                .find(
                  '.slick-current img[id|="qv-product-featured-image"]'
                )
                .attr("src");
          }
        

        // shopify no longer support properties[], but instead, only JSON instances, see 
        // https://community.shopify.com/c/technical-q-a/line-item-properties-not-saving-to-cart/td-p/2830042
        // for more details

        try {
          Object.keys(returnArray).forEach((elem)=>{
            try {
              if (elem.indexOf("properties[") != -1)
              {
                if (!returnArray.hasOwnProperty("properties"))
                {
                  returnArray["properties"] = {};
                }
                returnArray["properties"][elem.replace("properties[","").replace("]","")] = returnArray[elem];
              }
            } catch (exx)
            {
              console.log(exx);
            }
          });
          
        } catch (exxs)
        {
          console.log(exxs);
        }

        // Check if any cube face images exist
        let hasFiles = false;
        thisForm.find('input[type="file"][name^="images["]').each(function() {
          if (this.files.length > 0) hasFiles = true;
        });

        if (hasFiles) {
          doAjaxAddToCartWithFiles(scsformdata.items[0], handle);
          return false; // prevent the normal JSON add-to-cart
        }

          doAjaxAddToCartWUpsell(scsformdata, handle);
                    
          $("[data-compare-modal]").hide();
            
      }
    
      if ($(".cart-template").length != 0) {
        let dss = $(this).attr("data-threshold");
        $("[data-threshold='" + dss + "']").attr("disabled", true);
        $("[data-threshold='" + dss + "']").text("Locked");
        try {
          Shopify.getCart(function (cart) {
            doHandleFreeGifts(cart);
          });
        } catch (err) {
          console.log(err);
        }
      }
      return false;
    });
  
  $("[data-sticky-btn-addToCart]").click(function (e) {
    e.preventDefault();
  
    if ($("#add-to-cart-form [data-btn-addtocart]").length) {
      $("#add-to-cart-form [data-btn-addtocart]").click();
    } else if ($("#add-to-cart-form [data-grouped-addToCart]").length) {
      $("#add-to-cart-form [data-grouped-addToCart]").click();
    }
  
    return false;
  });

}

$(document).ready(()=> {
  initAddToCart();
  
  setTimeout(()=>{
    closeSuccessModal();
  },0);
  
  setTimeout(()=>{
    initChangeQuantityButtonEvent();
  },0);
  
  setTimeout(()=>{
    removeItemDropdownCart();
  },0);

  setTimeout(()=>{
    removeCartItem();
  },0);

  setTimeout(()=>{
    initAddToBundle();
  },0);

  setTimeout(()=>{
    initQuantityInputChangeEvent();
  },0);
  
});